import React, { useState } from "react";
import Modal from "react-modal";

import "./style.scss";

Modal.setAppElement("#root");

const VideoModal = ({ videoLink, buttonText }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <h5 onClick={openModal} className="video-modal-text">
        {buttonText}
      </h5>
      <Modal isOpen={isOpen} onRequestClose={closeModal} style={modalStyles}>
        <iframe
          style={iframeStyle}
          src={`https://www.youtube.com/embed/${videoLink}`}
          title="YouTube video"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      </Modal>
    </>
  );
};

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "0",
    borderRadius: "12px",
    width: "90vw",
    maxWidth: "800px",
    height: "auto",
    overflow: "hidden",
  },
};

// Responsive iframe
const iframeStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  border: 0,
};

export default VideoModal;
